const ProblemSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="section-container">
        <h2 className="text-sm font-semibold uppercase tracking-widest text-primary mb-4 animate-fade-up">
          The Problem
        </h2>
        
        <div className="max-w-2xl space-y-6 text-lg leading-relaxed text-muted-foreground">
          <p className="animate-fade-up-delay-1">
            <span className="text-foreground font-medium">You're not short on ideas. You're short on a system.</span>
          </p>
          
          <p className="animate-fade-up-delay-1">
            Right now your ideas live in Apple Notes, Simplenote, random notebooks, voice memos, and that napkin from the coffee shop. Some are gold. Most are noise. But you can't tell which is which because finding anything takes longer than the idea is worth.
          </p>
          
          <p className="animate-fade-up-delay-2">
            You've tried Notion, Trello, Asana. They're built for projects, not sparks. By the time you've set up a board, the idea is cold.
          </p>
          
          <p className="animate-fade-up-delay-3">
            So the ideas pile up. The notebooks become junk drawers. And the one idea that could have changed everything? It's on page 47 of a Moleskine you haven't opened in eight months.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
